import { render, staticRenderFns } from "./PublicDashboardPlatform.vue?vue&type=template&id=d9fa952e&scoped=true"
import script from "./PublicDashboardPlatform.vue?vue&type=script&lang=js"
export * from "./PublicDashboardPlatform.vue?vue&type=script&lang=js"
import style0 from "./PublicDashboardPlatform.vue?vue&type=style&index=0&id=d9fa952e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9fa952e",
  null
  
)

export default component.exports